$(document).ready(function () {

    console.log('Loaded content');

    if($('.quantity__button')[0].parentElement.children[1].attributes[4].value == 0){
        $('.quantity__button')[0].parentElement.children[1].attributes[4].value = 1;
    }

    var currentUrl = String(window.location.href);

    if (currentUrl.indexOf('/product') != -1) {
        setTimeout(function () {
            $('.pp_variant_sel.active').trigger('click');
        }, 1000);
    }

    var firstSection = $('.ppPack').first();

    if (firstSection.hasClass('sub')) {
        var sellingPlan = $('.ppSellingPlans').val(); // Get the selected selling plan value
        $('.pp_atc_form__Sel').val(sellingPlan); // Set the value of the hidden input
    } else {
        $('.pp_atc_form__Sel').val(''); // Clear the value if `sub` is not the first
    }


    $('.ppSellingPlans').change(function () {
        var sellingPlan = $('.ppSellingPlans').val();
        $('.pp_atc_form__Sel').attr('value', sellingPlan);

        var sellingTitle = $(this).find('option:selected').html();

        $('.pp_shipping_frequency').html(sellingTitle);
    });
    //does nothing
    $('.pp_mode_sel__js').click(function () {
        $('.pp_mode_sel__js').removeClass('active');
        $(this).addClass('active');

        $('.pp_Form_prices_one').hide();
        $('.pp_Form_prices_subs').hide();

        var data = $(this).attr('data');
        console.log(data);
        var firstSection = $('.ppPack').first();

        if (firstSection.hasClass('sub')) {
            // If 'sub' is on top, set it as active
            console.log('sub');
            $('.ppPack.sub').addClass('active');
            $('.pp_mode_sel__js[data="autodelivery"]').addClass('active');
            $('.sub_delivery_selection').show();
            $('.sub_content').show();
            $('.otp_content').hide();
        } else if (firstSection.hasClass('otp')) {
            console.log('otp');
            // If 'otp' is on top, set it as active
            $('.ppPack.otp').addClass('active');
            $('.pp_mode_sel__js[data="onetime"]').addClass('active');
            $('.sub_delivery_selection').hide();
            $('.sub_content').hide();
            $('.otp_content').show();
        }

        checkPricing();
    });


    $('.pp_qty_plus').click(function () {
        var currentQty = parseFloat($('.pp_qty_val').html());
        currentQty++;
        $('.pp_qty_val').html(currentQty);
        $('.pp_atc_form__Qty').val(currentQty);
    });

    $('.pp_qty_min').click(function () {
        var currentQty = parseFloat($('.pp_qty_val').html());
        if (currentQty > 1) {
            currentQty--;
            $('.pp_qty_val').html(currentQty);
            $('.pp_atc_form__Qty').val(currentQty);
        }

    });

    // When a kaching bundle bar is clicked, visually deselect the ppPack options
    $(document).on('click', '.needsclick', function () {
        setTimeout(function () {
            if ($('.kaching-bundles__bar--selected').length) {
                $('.ppPack').removeClass('active');
            }
        }, 80);
    });

    $('.ppPack').click(function () {
        // Clear kaching bundle selection when user picks a standard pack option
        $('.kaching-bundles__bar--selected').removeClass('kaching-bundles__bar--selected');
        $('.ppPack').removeClass('active');
        $(this).addClass('active');

        var currentQty = parseFloat($('.quantity__input').val()) || 1;

        $('.pp_form_prices_qty_1').show();

        checkPricing();

        $('.pp_atc_form__Qty').attr('value', currentQty);
        if (this.classList.contains('otp')) {
            $('.ppAtcBtn').closest('.t4s-form__product').find('.pp_atc_form__Sel').attr('value', '');
        } else {
            var sellingPlan = $('.ppSellingPlans').val();
            $('.ppAtcBtn').closest('.t4s-form__product').find('.pp_atc_form__Sel').attr('value', sellingPlan);
        }

    });

    // Helper: decode HTML entities (because data-images is HTML-escaped)
    function decodeHtmlEntities(str) {
        if (!str) return '';
        var txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    }

    // Helper: parse variant images metafield JSON into an array of URLs
    function parseVariantImagesJson(jsonString) {
        if (!jsonString) return [];
        try {
            var decoded = decodeHtmlEntities(jsonString);
            var data = JSON.parse(decoded);
            if (!Array.isArray(data)) return [];
            var urls = [];
            data.forEach(function (item) {
                if (!item || typeof item !== 'object') return;
                var lang = item.language || item.ImageLanguage || '';
                lang = String(lang);
                
                if (lang && !(lang.indexOf('US') !== -1 || lang.indexOf('en') !== -1)) return;
                var url = item.image_url || item.ImageUrl || '';
                if (url) urls.push(url);
            });
            return urls;
        } catch (e) {
            console && console.warn && console.warn('Failed to parse variant images metafield', e);
            return [];
        }
    }

    var ppMainBadgeHtml = null;
    function updateVariantImageGalleryFromMetafield(jsonString) {
        if (window.location.pathname.indexOf('/products/') !== 0) return;
        var urls = parseVariantImagesJson(jsonString);
        if (!urls.length) return;

        var mainSwiperEl = document.querySelector(
            '.product__media-wrapper .slider-element.ttt .swiper'
        );
        var thumbsSwiperEl = document.querySelector(
            '.product__media-wrapper .slider-element.slider-thumbs .swiper'
        );

        if (!ppMainBadgeHtml && mainSwiperEl) {
            var firstSlide = mainSwiperEl.querySelector('.swiper-wrapper .swiper-slide');
            if (firstSlide) {
                var badgeEl = firstSlide.querySelector('[data-snippet="product-badges"]');
                if (badgeEl) {
                    ppMainBadgeHtml = badgeEl.outerHTML;
                }
            }
        }

        if (mainSwiperEl && mainSwiperEl.swiper && typeof mainSwiperEl.swiper.removeAllSlides === 'function') {
            var mainSwiper = mainSwiperEl.swiper;
            var mainSlidesHtml = urls.map(function (url, index) {
                var html = '<div class="swiper-slide" data-test="us">';
                if (index === 0 && ppMainBadgeHtml) {
                    html += ppMainBadgeHtml;
                }
                html += '<img ' + (index > 0 ? 'loading="lazy" ' : '') + 'src="' + url + '" alt="">';
                html += '</div>';
                return html;
            });
            mainSwiper.removeAllSlides();
            mainSwiper.appendSlide(mainSlidesHtml);
            mainSwiper.slideTo(0);
            if (typeof mainSwiper.update === 'function') {
                mainSwiper.update();
            }
        }

        if (thumbsSwiperEl && thumbsSwiperEl.swiper && typeof thumbsSwiperEl.swiper.removeAllSlides === 'function') {
            var thumbsSwiper = thumbsSwiperEl.swiper;
            var thumbSlidesHtml = urls.map(function (url) {
                return '' +
                    '<div class="swiper-slide">' +
                    '<div class="thumbnail-list__item">' +
                    '<span class="thumbnail">' +
                    '<img loading="lazy" src="' + url + '" alt="">' +
                    '</span>' +
                    '</div>' +
                    '</div>';
            });
            thumbsSwiper.removeAllSlides();
            thumbsSwiper.appendSlide(thumbSlidesHtml);
            thumbsSwiper.slideTo(0);
            if (typeof thumbsSwiper.update === 'function') {
                thumbsSwiper.update();
            }
        }
    }

    $('.pp_variant_sel').click(function () {
        $(this).closest('.pp_variant_selection').find('.pp_variant_sel').removeClass('active');
        $(this).addClass('active');

        var currentId = $(this).attr('data-id');

        if ($(this).hasClass('qz_product')) {
            $(this).closest('.qz_product_cell_content').find('.pp_default_pricing').hide();
            $(this).closest('.qz_product_cell_content').find('.pp_default_pricing[data-id="' + currentId + '"]').css('display', 'flex');

            $(this).closest('.qz_product_cell_content').find('.qz_product_card_atc').attr('data-id', currentId);
        } else {
            $('.pp_default_pricing').hide();
            $('.pp_default_pricing[data-id="' + currentId + '"]').css('display', 'flex');

            $('.pp_form_prices__js').hide();
            $('.pp_form_prices__js[data-id="' + currentId + '"]').show();

            $('.ppPackPrice_cont').hide();
            $('.ppPackPrice_cont[data-id="' + currentId + '"]').show();

            $('.pp_sku__js').hide();
            $('.pp_sku__js[data-id="' + currentId + '"]').show();

            $('.pp_square_img__js').hide();
            $('.pp_square_img__js[data-id="' + currentId + '"]').show();

            checkPricing();

            $('.pp_atc_form__Var').attr('value', currentId);

            $('.ppUpdPrice__js').hide();
            $('.ppUpdPrice__js[data-id="' + currentId + '"]').show();


            //  Updated layout
            $('.pp_bundle_price_upd').hide();
            $('.pp_bundle_price_upd[data-id="' + currentId + '"]').show();

            var currentInv = $('.pp_variant_sel.active').attr('data-inv');
            if (currentInv == '0') {
                $('.ppAtcBtn').prop('disabled', true);
                $('.ppAtcBtn').find('.text').html('Sold out');
                $('.ppAtcBtn')[0].classList.add('pp_out_of_stock');
                $('#Globo-Back-In-Stock').show();
            } else {
                $('.ppAtcBtn').prop('disabled', false);
                $('.ppAtcBtn').find('.text').html('Add to cart');
                $('.ppAtcBtn')[0].classList.remove('pp_out_of_stock');
            }
        }

        $(this).closest('.qz_product_cell').find('.qz_product_card_pricing_line').hide();
        $(this).closest('.qz_product_cell').find('.qz_product_card_pricing_line[data-id="' + currentId + '"]').show();

        $(this).closest('.qz_product_cell').find('.qz_product_card_atc').attr('data-id', currentId);

        // Update Swiper galleries to show ONLY the current variant's metafield images
        var imagesJson = $(this).attr('data-images');
        if (!$(this).hasClass('qz_product')) {
            updateVariantImageGalleryFromMetafield(imagesJson);
        }

    });


    function checkPricing() {
        setTimeout(function () {

            var currentId = $('.pp_variant_sel.active').attr('data-id');
            var dataMode = $('.ppPack.active')[0].classList.contains('sub');
            var currentPrice = parseFloat($('.pp_variant_sel[data-id="' + currentId + '"]').attr('data-price'));

            if (dataMode) {
                currentPrice = currentPrice * 0.55;
                $('.ppCompare').each(function () {
                    this.style.display = 'inline';
                });
            } else {
                $('.ppCompare').each(function () {
                    this.style.display = 'none';
                });
            }

            currentPrice = currentPrice / 100;

            if (currentPrice > 49) {
                $('.ppFreeShippingNote').css('opacity', '1');
                // $('.ppFreeShippingNote').html(currentPrice);
                $('.ppFeatrueShipping').show();
            } else {
                $('.ppFreeShippingNote').css('opacity', '0');
                // $('.ppFreeShippingNote').html(currentPrice);
                $('.ppFeatrueShipping').hide();
            }
            var currentPriceString = currentPrice.toFixed(2);

            $('.ppDataPrice').html('$' + currentPriceString);

        }, 50);

    }


    // Quiz popup
    $('.qz_product_popup_close').click(function () {

        $('.qz_product_popup_outer').hide();
        $('.qz_product_popup_in').css('opacity', '0');
    });

    $('.qz_product_card_view').click(function () {
        var currentId = $(this).attr('data-id');

        $('.qz_product_popup_outer[data-id="' + currentId + '"]').css('display', 'flex');
        setTimeout(function () {
            $('.qz_product_popup_in').css('opacity', '1');
        }, 800);
        $('.pp_carousel_main')[0].slick.refresh();
        $('.pp_carousel_thumb')[0].slick.refresh();

        $('.pp_Media.media_outer_cont').removeClass('loading');
    });
    $('.quantity__button').click(function () {
        var display = $(this)[0].parentElement.children[1];
        var currentQty = display.value;
        currentQty = parseFloat(currentQty);
        display.attributes[4].value = currentQty;
        $('.pp_atc_form__Qty').attr('value', currentQty);
    });
    $('.ppAtcBtn').click(function (e) {
        // If a kaching bundle pack is selected, delegate to kaching's own submit
        var $kachingSelected = $('.kaching-bundles__bar--selected');
        if ($kachingSelected.length) {
            e.preventDefault();
            e.stopImmediatePropagation();
            // Find kaching's CTA button (try common selectors)
            var $kachingCta = $('[class*="kaching"] [type="submit"], [class*="kaching"] button').not('.ppAtcBtn').first();
            if ($kachingCta.length) {
                $kachingCta.trigger('click');
            } else {
                // Fallback: submit the kaching form if present
                $('[class*="kaching"] form').first().submit();
            }
            return false;
        }

        var mainId = $(this).closest('.t4s-form__product').find('.pp_atc_form__Var').val();
        var mainQty = $(this).closest('.t4s-form__product').find('.pp_atc_form__Qty').val();
        var mainSellingPlan = $(this).closest('.t4s-form__product').find('.pp_atc_form__Sel').val();
        if (mainSellingPlan == '') {
            mainQty = $('.quantity__button')[0].parentElement.children[1].attributes[4].value;
            console.log('huzzah');
        }
        var data = {
            items: [{
                id: parseInt(mainId, 10),
                quantity: parseInt(mainQty, 10),
                selling_plan: parseInt(mainSellingPlan || null, 10),
            }]
        };
        console.log(data);

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",

            success: function (cart, response) {
                // refreshCartDrawer();
                // $('.cd_outer').show();
                // window.location = '/cart';
                setTimeout(function () {
                    // $('.cd_outer').addClass('active');
                }, 100);
            },
            error: function (err) {
                console.log("Error:", err.responseText);
            }
        });
    });
});